import script from "./modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal.vue?vue&type=script&setup=true&lang=ts"

import "./modal.vue?vue&type=style&index=0&id=a40e9942&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a40e9942"]])

export default __exports__